import { ExportToCsv } from 'export-to-csv-fix-source-map'
import { GoogleAuthProvider, onAuthStateChanged, signInWithPopup, User } from 'firebase/auth'
import { collection, getDocs } from 'firebase/firestore'
import { auth, db } from '../firebase'
import styles from '../assets/scss/components/admin.module.scss'
import { useEffect, useState } from 'react'
import { FirebaseError } from 'firebase/app'

export const Admin: React.FC = () => {
  const [authUser, setAuthUser] = useState<User | null>()
  const [error, setError] = useState<FirebaseError>()

  const handleAuth = () => {
    const googleProvider = new GoogleAuthProvider()
    signInWithPopup(auth, googleProvider)
  }

  useEffect(() => {
    const handleAuthStateChanged = onAuthStateChanged(auth, async (user) => {
      setAuthUser(user)

      if (user) {
        try {
          const docRef = await getDocs(collection(db, 'entries'))
          const entries = docRef.docs.map((entry) => entry.data())
          const csvExporter = new ExportToCsv({
            headers: [
              'Name',
              'Age',
              'Email',
              'Telephone number',
              'Postcode',
              'Float name 1',
              'Float name 2',
              'Float name 3',
              'Reason',
              // 'Accept terms?',
            ],
            showLabels: true,
          })

          csvExporter.generateCsv(
            entries.map(({ entry }) => {
              return {
                name: entry.name,
                age: entry.age,
                email: entry.email,
                tel: entry.tel,
                postCode: entry.postCode,
                floatName: entry.floatName,
                reason: entry.reason,
                // terms: entry.terms,
              }
            }),
          )
        } catch (error) {
          if (error instanceof FirebaseError) {
            setError(error)
          }
        }
      }
    })

    return handleAuthStateChanged
  }, [])

  if (error) {
    return <div className={styles.admin}>{error.message}</div>
  }

  return (
    <div className={styles.admin}>
      <button disabled={!!authUser} onClick={handleAuth}>
        Authenticate and download
      </button>
    </div>
  )
}
